import React, { useEffect, useState } from "react";
import Header from "../../../../components/Header/Header";
import LeftSideBar from "../../../../components/LeftSideBar/LeftSideBar";
import {
  Grid,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import AdministratorHeader from "../../../../components/Header/AdministratorHeader";
import "./auditHistory.scss";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "jspdf-autotable";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { font } from "../../../../components/Fonts/Roboto/Roboto-Medium.js";
import * as acts from "../../../../redux/administrator/actions.js";
import CustomizedSnackbars from "../../../../components/Snackbars/CustomizedSnackbars.jsx";
import ProgressBar from "../../../../components/ProgressBar.jsx";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs || {};

if (!pdfMake.vfs["Roboto-Medium.ttf"]) {
  pdfMake.vfs["Roboto-Medium.ttf"] = font;
}

// pdfmake.vfs = pdfFonts.pdfMake.vfs;
// window.pdfMake.vfs["Roboto-Medium.ttf"] = font;

function Index(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const previewData = useSelector((state) => state?.admin?.previewHistoryData);
  const [isOpen, setIsOpen] = useState(false);

  let apiStatus = useSelector((state) => state?.admin?.apiStatus);
  // console.log(props.location.state, "propssssssssssss");

  const [clonnedAuditHistory, setClonnedAuditHistory] = useState([]);
  useEffect(() => {
    dispatch(
      acts.getPreviewHistoryData({
        obj_id: location?.state?.objectId,
      })
    );
    dispatch(acts.clearApiStatus());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (previewData && previewData !== clonnedAuditHistory) {
      setClonnedAuditHistory(previewData?.data?.parametersData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewData]);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (
        apiStatus?.loader === false &&
        apiStatus?.message !== null &&
        apiStatus?.apiSuccess === true &&
        apiStatus?.next === true
      ) {
        setIsOpen(true);
        setMessage(apiStatus?.message);
        setSeverity("success");
        setLoader(false);

        dispatch(acts.clearApiStatus());
      }
      if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setIsOpen(true);
        setMessage(apiStatus?.message);
        setSeverity("error");
        setLoader(false);
        dispatch(acts.clearApiStatus());
      }
    }
  }, [apiStatus]);

  const restoreDataHistory = () => {
    const data = {
      batch_id: location?.state?.batchId,
      obj_id: location?.state?.objectId,
    };
    dispatch(acts.restoreHistoryData(data));
    setLoader(true);
  };

  const handleCloseSnackbar = () => {
    setIsOpen(false);
    if (severity === "success") navigate(-1);
  };

  const DataTable = ({ data, extractionType }) => {
    // Function to render table rows based on the provided data
    const renderTableRows = () => {
      return data?.map((item, index) => (
        <TableRow key={index}>
          <TableCell>{index + 1}</TableCell> {/* Serial number */}
          <TableCell>
            {extractionType === "template_driven"
              ? item?.parameter
              : item?.query}
          </TableCell>
          <TableCell>{item?.dataType ? item?.dataType : "-"}</TableCell>
          <TableCell>{item?.range?.min}</TableCell>
          <TableCell>{item?.range?.max}</TableCell>
          {item?.mappings?.map((mapping, mappingIndex) => (
            <TableCell key={mappingIndex}>{String(mapping?.value)}</TableCell>
          ))}
        </TableRow>
      ));
    };

    return (
      <Box className="audit-history-table-container">
        <TableContainer
          component={Paper}
          className="audit-history-table-container"
        >
          <Table stickyHeader>
            <TableHead className="audit-history-table-head">
              <TableRow>
                <TableCell>Sr.</TableCell>
                <TableCell>Parameter Name</TableCell>
                <TableCell>Data Type</TableCell>
                <TableCell>Min Range</TableCell>
                <TableCell>Max Range</TableCell>

                {data &&
                  data?.length >= 0 &&
                  data[0]?.mappings?.map((mapping, mappingIndex) => (
                    <TableCell key={mappingIndex}>
                      {String.fromCharCode(65 + mappingIndex)}
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>
            <TableBody>{renderTableRows()}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader
              text={
                location?.state?.isBatchHistory
                  ? "Batch History"
                  : "Project History"
              }
              isArrow="true"
            />
          </Grid>
          <Box sx={{ position: "absolute", right: "27px", paddingTop: "4px" }}>
            <Button
              className="btn-continue"
              onClick={() => restoreDataHistory()}
              size="small"
            >
              {" "}
              Restore
            </Button>
          </Box>
          <Grid item className="admin-data-table">
            <Box>
              <DataTable
                data={clonnedAuditHistory}
                extractionType={previewData?.data?.extractionType}
              />
            </Box>
          </Grid>
          {loader && <ProgressBar></ProgressBar>}
          {isOpen && (
            <CustomizedSnackbars
              className="popup"
              handleClose={() => {
                handleCloseSnackbar();
              }}
              severity={severity}
              state={isOpen}
              text={message}
            />
          )}
        </Grid>
      </Box>
    </>
  );
}

export default Index;
